import {useEffect, type RefObject} from 'react';

export const CHAT_MIN_HEIGHT = 300;

export const CHAT_HEIGHT_PROPERTY = '--new-aside-chat-height';

const topWithin = (element: Element, container: Element): number => element.getBoundingClientRect().top -
    container.getBoundingClientRect().top;

const bottomWithin = (element: Element, container: Element): number => element.getBoundingClientRect().bottom -
    container.getBoundingClientRect().top;

const alignChat = (aside: HTMLElement): void => {
    const chat = aside.querySelector('.chat__content')?.closest('.chat');
    const cup = document.querySelector('.aside--left .cup-aside');
    const cupColumn = cup?.closest('.aside__inner');

    if (!chat || !cupColumn || !cup.querySelector('.aside-item-body_opened')) {
        aside.style.removeProperty(CHAT_HEIGHT_PROPERTY);

        return;
    }

    const height = Math.max(CHAT_MIN_HEIGHT, bottomWithin(cup, cupColumn) - topWithin(chat, aside));

    aside.style.setProperty(CHAT_HEIGHT_PROPERTY, `${height}px`);
};

export const useChatAlignedToCup = (ref: RefObject<HTMLElement>, enabled: boolean): void => {
    useEffect(() => {
        const aside = ref.current;

        if (!enabled || !aside) {
            return () => null;
        }

        const align = (): void => alignChat(aside);
        const resizeObserver = new ResizeObserver(align);

        const observeColumns = (): void => {
            const leftColumn = document.querySelector('.aside--left > .aside__inner');

            resizeObserver.observe(aside);

            if (leftColumn) {
                resizeObserver.observe(leftColumn);
            }
        };

        const mutationObserver = new MutationObserver(() => {
            observeColumns();
            align();
        });
        const wrap = aside.closest('.wrap');

        if (wrap) {
            mutationObserver.observe(wrap, {childList: true});
        }

        observeColumns();
        align();

        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            aside.style.removeProperty(CHAT_HEIGHT_PROPERTY);
        };
    }, [enabled, ref]);
};
